import { isEmail } from 'components/forms/inputs/EmailListInput';

export const splitMultilineHtmlText = (inputString: string): string => {
    return inputString
        .split('\n')
        .map((paragraph) => (paragraph ? `<p>${paragraph}</p>` : '<br/>'))
        .join('');
};

export const stringToEmailList = (input?: string | null): string[] => {
    if (!input) return [];
    const splitList = input.split(/[,;]/);
    const emailList = splitList.map((val) => val.trim()).filter((val) => isEmail(val));
    return [...new Set(emailList)];
};

export const combinePrimaryRecipientEmails = (
    mainEmail?: string | null,
    additionalEmails?: string | null,
    skipMainEmailWhenAdditionalProvided = false
): string[] => {
    const additionalEmailList = stringToEmailList(additionalEmails);
    if (skipMainEmailWhenAdditionalProvided && additionalEmailList.length) {
        return additionalEmailList;
    }
    return [...new Set([...(mainEmail ? [mainEmail] : []), ...additionalEmailList])];
};

export const buildHtmlForMultilineText = (inputString: string): string => {
    return inputString?.replace(/\n/g, '<br/><br/>');
};
